import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core'
import { takeUntil } from 'rxjs/operators'
import { ITrack } from '../../../Interface/track'
import { AuthService } from '../../../services/auth.service'
import { DestroyService } from '../../../services/destroy.service'
import { InfoPopupService } from '../../../services/info-popup.service'
import { I18nService, LgType } from '../../../services/prod/i18n.service'
import { TracksService } from '../../../services/tracks.service'
import { BtnClassNameType, IconButtonSize } from '../button.types'

@Component({
  selector: 'bmcore-fav-btn',
  templateUrl: './bmcore-fav-btn.component.html',
  styleUrls: ['./bmcore-fav-btn.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class BmcoreFavBtnComponent implements OnInit {
  @Input() track: ITrack
  @Input() dropdownMode = false

  @Input() iconSize = 24

  @Input() showIconBtnVariant = false
  @Input() iconButtonSize: IconButtonSize

  lg: LgType
  isFavorite = false

  constructor(
    private i18nService: I18nService,
    private tracksService: TracksService,
    private authService: AuthService,
    private infoPopupService: InfoPopupService,
    private readonly destroy$: DestroyService,
    private readonly cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.lg = this.i18nService.getLanguageForPage()
    this.isFavorite = !!this.track?.addedToFavorite

    this.tracksService.changeFavoriteStatusEvent.pipe(takeUntil(this.destroy$)).subscribe(beatId => {
      if (this.track && this.track.id === beatId) {
        this.isFavorite = !this.isFavorite
        this.cdr.markForCheck()
      }
    })
  }

  toggleFavoriteTrackHandler(e: MouseEvent) {
    e.stopPropagation()
    if (this.authService.isAuthenticated) {
      this.tracksService.changeBeatFavoriteStatus(this.track.id)
    } else {
      this.infoPopupService.notify('“Add Favorites”')
    }
  }

  getIconBtnVariant(): BtnClassNameType {
    return `icon-${this.iconButtonSize}`
  }
}
